module.exports = __webpack_public_path__ + "static/img/3.6fa99a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/3.png
// module id = K6mk
// module chunks = 1